<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useFandataPerfil } from 'dashboard/composables/useFandataPerfil';
import { PERFIS_FANDATA } from 'dashboard/helper/fandataPerfis';

import {
  DropdownContainer,
  DropdownBody,
  DropdownSection,
  DropdownItem,
} from 'next/dropdown-menu/base';
import Button from 'next/button/Button.vue';

// "Ver como" (02/10) — o seletor de pré-visualização dentro do menu do perfil.
//
// O pedido veio da devolutiva de 01/10: a Tamara precisava conferir, tela a tela, o que cada um
// dos seis perfis enxerga. O caminho que existia era se dar o perfil de verdade na tela de
// agentes, o que troca também o papel nativo e derruba o próprio acesso de administrador.
//
// Aqui nada é gravado: a escolha vive no navegador de quem está olhando. Por isso só aparece
// para quem tem papel nativo de administrador, que é quem já veria tudo de qualquer jeito.

const { t } = useI18n();
const { perfilReal, preVisualizando, podePreVisualizar, verComo } =
  useFandataPerfil();

const nome = chave => t(`AGENT_MGMT.PERFIS.${chave.toUpperCase()}`);

const opcoes = computed(() =>
  PERFIS_FANDATA.map(p => ({
    chave: p.chave,
    label: nome(p.chave),
    ativo: (preVisualizando.value || perfilReal.value) === p.chave,
  }))
);

const rotuloAtual = computed(() =>
  preVisualizando.value
    ? nome(preVisualizando.value)
    : t('SIDEBAR_ITEMS.VER_COMO.MINHA_VISAO')
);
</script>

<template>
  <DropdownSection v-if="podePreVisualizar" class="[&>ul]:overflow-visible">
    <div class="grid gap-0">
      <DropdownItem preserve-open class="gap-1">
        <div class="flex-grow flex items-center gap-1 min-w-0">
          {{ t('SIDEBAR_ITEMS.VER_COMO.TITULO') }}
        </div>
        <DropdownContainer class="shrink-0">
          <template #trigger="{ toggle }">
            <Button
              size="sm"
              color="slate"
              variant="faded"
              icon="i-lucide-chevron-down"
              trailing-icon
              @click="toggle"
            >
              <span class="truncate max-w-[8rem] text-sm">
                {{ rotuloAtual }}
              </span>
            </Button>
          </template>
          <DropdownBody class="min-w-44 z-20">
            <DropdownItem
              v-for="opcao in opcoes"
              :key="opcao.chave"
              :label="opcao.label"
              :icon="
                opcao.ativo ? 'i-lucide-check' : 'i-lucide-minus opacity-0'
              "
              class="cursor-pointer"
              @click="verComo(opcao.chave === perfilReal ? null : opcao.chave)"
            />
          </DropdownBody>
        </DropdownContainer>
      </DropdownItem>
      <p class="px-2 pb-1 m-0 text-xs text-n-slate-11">
        {{ t('SIDEBAR_ITEMS.VER_COMO.AJUDA') }}
      </p>
    </div>
  </DropdownSection>
</template>
